import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ProfileFormFieldsProps {
  formData: {
    first_name: string;
    last_name: string;
    bio: string;
    phone: string;
  };
  isEditing: boolean;
  onChange: (field: string, value: string) => void;
}

const ProfileFormFields = ({ formData, isEditing, onChange }: ProfileFormFieldsProps) => {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="first_name">First Name</Label>
        <Input
          id="first_name"
          value={formData.first_name}
          onChange={(e) => onChange("first_name", e.target.value)}
          disabled={!isEditing}
          placeholder="Enter your first name"
          className="bg-white"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="last_name">Last Name</Label>
        <Input
          id="last_name"
          value={formData.last_name}
          onChange={(e) => onChange("last_name", e.target.value)}
          disabled={!isEditing}
          placeholder="Enter your last name"
          className="bg-white"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="bio">Bio</Label>
        <Input
          id="bio"
          value={formData.bio}
          onChange={(e) => onChange("bio", e.target.value)}
          disabled={!isEditing}
          placeholder="Tell us about yourself in one line"
          className="bg-white"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="phone">Phone</Label>
        <Input
          id="phone"
          value={formData.phone}
          onChange={(e) => onChange("phone", e.target.value)}
          disabled={!isEditing}
          placeholder="Enter your phone number"
          className="bg-white"
        />
      </div>
    </div>
  );
};

export default ProfileFormFields;